// Generated-photo file naming, driven by the user's naming settings
// (user.settings.photoNameSettings). The name is always:
//
//     <prefix>[ - <YYYY-MM-DD>] - <serial>
//
// where <prefix> comes from the chosen mode:
//   • 'full'   → the shop name as-is (default, matches legacy behaviour)
//   • 'short'  → the first character of every word of the shop name
//   • 'custom' → free text the user typed (falls back to 'full' when empty)
// The serial is supplied by the caller (nextPhotoSerial for the AI editor, a
// device-local counter for the manual editor) — users see it, they don't edit it.
// It restarts daily while the date is in the name, and runs on forever without it.

export const DEFAULT_PHOTO_NAME_SETTINGS = {
    mode: 'full',       // 'full' | 'short' | 'custom'
    custom: '',
    includeDate: true,
};

const sanitize = (s) => String(s || '').replace(/[\\/:*?"<>|]/g, '-').trim();

/** "নয়ন ফটো স্টুডিও" → "নফস", "Nayan Photo Studio" → "NPS" */
export function shopInitials(name) {
    return String(name || '')
        .trim()
        .split(/\s+/)
        .map((w) => w[0])
        .filter(Boolean)
        .join('');
}

/** Resolve the prefix part of the name for the given settings. */
export function buildPhotoPrefix(shopName, settings) {
    const s = { ...DEFAULT_PHOTO_NAME_SETTINGS, ...(settings || {}) };
    const base = sanitize(shopName) || 'Sohozkaj';
    if (s.mode === 'short') return shopInitials(base) || base;
    if (s.mode === 'custom') return sanitize(s.custom) || base;
    return base;
}

/** Full display name (no extension): "prefix - 2026-08-26 - 3" */
export function buildPhotoDisplayName({ shopName, settings, serial }) {
    const s = { ...DEFAULT_PHOTO_NAME_SETTINGS, ...(settings || {}) };
    const parts = [buildPhotoPrefix(shopName, s)];
    if (s.includeDate !== false) parts.push(new Date().toISOString().slice(0, 10));
    parts.push(String(serial ?? 1));
    return parts.join(' - ');
}

const escapeRe = (s) => String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Next serial for the current prefix+date, derived from EXISTING image names
 * (e.g. the loaded history's fileNames) rather than a backend counter — so the
 * trailing number reliably increments off the last saved image ("… - N").
 * With the date ON the serial restarts each day (only today's names count).
 * With the date OFF it never resets: every name with this prefix counts, dated
 * or not, so the numbering keeps climbing across days (1, 2, 3, 4 …).
 * Returns 1 when nothing matches yet. `existingNames` may carry an optional
 * extension, which is ignored.
 */
export function nextPhotoSerial({ shopName, settings, existingNames = [] }) {
    const s = { ...DEFAULT_PHOTO_NAME_SETTINGS, ...(settings || {}) };
    const prefix = escapeRe(buildPhotoPrefix(shopName, s));
    const datePart = s.includeDate !== false
        ? ` - ${escapeRe(new Date().toISOString().slice(0, 10))}`
        : '(?: - \\d{4}-\\d{2}-\\d{2})?';
    const re = new RegExp(`^${prefix}${datePart} - (\\d+)(?:\\.[^.]+)?$`);
    let max = 0;
    for (const name of existingNames) {
        const m = re.exec(String(name || '').trim());
        if (m) max = Math.max(max, parseInt(m[1], 10) || 0);
    }
    return max + 1;
}
